import classNames from 'classnames';

import { LiveQuizConnectionState } from '../../services/liveQuizSocket';

interface ConnectionBadgeProps {
    state: LiveQuizConnectionState;
}

const stateLabels: Record<LiveQuizConnectionState, string> = {
    connecting: 'Connecting',
    connected: 'Live',
    reconnecting: 'Reconnecting',
    closed: 'Offline',
};

const stateDotStyles: Record<LiveQuizConnectionState, string> = {
    connecting: 'bg-amber-500 animate-pulse',
    connected: 'bg-emerald-500',
    reconnecting: 'bg-amber-500 animate-pulse',
    closed: 'bg-slate-400 dark:bg-slate-600',
};

const ConnectionBadge: React.FC<ConnectionBadgeProps> = ({ state }) => (
    <span
        className="flex items-center gap-1.5 text-xs font-medium text-slate-600 dark:text-slate-400"
        title={`Realtime connection: ${stateLabels[state]}`}
    >
        <span className={classNames('w-2 h-2 rounded-full', stateDotStyles[state])} />
        <span className="hidden sm:inline">{stateLabels[state]}</span>
    </span>
);

export default ConnectionBadge;
